var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"logout text-uppercase",on:{"click":function($event){$event.preventDefault();return _vm.doLogout()}}},[_vm._v("Logout")])])
}
var staticRenderFns = []

export { render, staticRenderFns }